import {
  Component,
  ElementRef,
  computed,
  inject,
  input
} from '@angular/core';
import { Hex } from 'viem';
import { ProfileCardOverlayService } from '../../services/profile-card-overlay.service';
import { ServerService } from '../../services/server.service';
import { IdentityComponent } from '../identity/identity.component';

// Click opens the profile preview card; the card surfaces the full address.
@Component({
  selector: 'app-name-reveal',
  imports: [IdentityComponent],
  template: `
    <app-identity
      [username]="identity().username"
      [twitterHandle]="identity().twitterHandle"
      [fallback]="fallback()"
    ></app-identity>
  `,
  styles: [
    `
      :host {
        display: inline;
        cursor: pointer;
      }
    `,
  ],
  host: {
    '[style.color]': 'hostColor',
    '[attr.title]': 'hostTitle',
    '(click)': 'onClick($event)',
  },
})
export class NameRevealComponent {
  readonly address = input.required<Hex>();
  readonly username = input<string | null>(null);
  readonly twitterHandle = input<string | null>(null);
  readonly fallback = input<string>('');
  readonly color = input<string | null>(null);
  readonly withProfilePreview = input<boolean>(false);

  private readonly overlay = inject(ProfileCardOverlayService);
  private readonly server = inject(ServerService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  // Log events freeze whatever identity the server knew when it appended them, so a
  // handle linked later never appears — presence fills the gaps at render time.
  protected readonly identity = computed(() =>
    this.server.resolveIdentity({
      address: this.address(),
      username: this.username(),
      twitterHandle: this.twitterHandle(),
    }),
  );

  get hostColor() {
    return this.color();
  }
  readonly hostTitle = 'View profile';

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.withProfilePreview()) return;
    this.overlay.openFor({
      address: this.address(),
      username: this.identity().username,
      twitterHandle: this.identity().twitterHandle,
      anchor: this.elementRef.nativeElement,
    });
  }
}
